<template>
    <div>
        <div>
            <app-tabela
                :itens="contrato.ocorrenciasInternas"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
            </app-tabela>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'dtOcorrencia',
                    label: 'Data da Ocorrência',
                    sortable: true,
                    type: 'datetime'
                },
                {
                    key: 'usrLogin',
                    label: 'Usuário',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ocorrencia',
                    label: 'Ocorrência',
                    filterable: true
                }
            ],
            itensPorPagina: 10
        }
    }
}
</script>
